import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageDsSections from './pages/ds_sections.js'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import editor from './modules/editor'
import buscaTypesense from './modules/busca-typesense'
import textosScripts from './pages/Textos'
import editorIos from './modules/editor-ios'

// import SvgUse from "./utils/SvgUse";

// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
console.log('teste')

// Pages
PageHome()
PageDsSections()
PageLogin()?.init()

// utils logs
editor()
buscaTypesense()
logs()


//lógica de tradução
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.traducao')
  const elementosIngles = document.querySelectorAll('.ingles')
  const elementosPortugues = document.querySelectorAll('.portugues')

  function toggleIdioma(idiomaSelecionado) {
    if (idiomaSelecionado === 'ingles') {
      elementosIngles.forEach((el) => el.classList.remove('hidden'))
      elementosPortugues.forEach((el) => el.classList.add('hidden'))
    } else {
      elementosIngles.forEach((el) => el.classList.add('hidden'))
      elementosPortugues.forEach((el) => el.classList.remove('hidden'))
    }

    buttons.forEach((button) => {
      const isEnglish = button.textContent.trim() === 'English'
      button.classList.toggle('hidden', isEnglish === (idiomaSelecionado === 'ingles'))
    })

    localStorage.setItem('idiomaSelecionado', idiomaSelecionado)
  }

  // Definir português como padrão se não houver idioma salvo
  const idiomaSalvo = localStorage.getItem('idiomaSelecionado') || 'portugues'
  toggleIdioma(idiomaSalvo)

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      const idioma = this.textContent.trim() === 'English' ? 'ingles' : 'portugues'
      toggleIdioma(idioma)
    })
  })




	Fancybox.bind("[data-fancybox]", {
		// configurações opcionais
	});
})


textosScripts()
 
editorIos()


  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-wrapper').forEach(wrapper => {
      const iframe = wrapper.querySelector('.video-iframe')
      const thumb = wrapper.querySelector('.video-thumb')
      const player = new Vimeo.Player(iframe)

      // Ao clicar na thumb
      thumb.addEventListener('click', () => {
        thumb.style.display = 'none';
						
        player.play()
      })
	

      // Quando o vídeo termina
      player.on('ended', () => {
        thumb.style.display = 'block'
        player.unload() // reseta o vídeo
      })
    })
  })


document.addEventListener("DOMContentLoaded", function() {
    const listaBtn = document.getElementById("lista-button");
    const gridBtn = document.getElementById("grid-button");

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth" // rolagem suave
        });
    }

    if (listaBtn) {
        listaBtn.addEventListener("click", scrollToTop);
    }

    if (gridBtn) {
        gridBtn.addEventListener("click", scrollToTop);
    }
});

